<template>
    <div v-if="instrutorSelecionado" class="perfil-container">
        <div class="perfil-header">
            <div class="foto-container">
                <div class="foto-placeholder" @click="triggerFileInput">
                    <img v-if="fotoPerfil" :src="fotoPerfil" alt="Foto do instrutor" class="foto-instrutor" />
                    <AccountCircle v-else :size="120" />
                </div>
                <input 
                    type="file" 
                    ref="fileInput" 
                    accept=".jpg,.jpeg" 
                    style="display: none" 
                    @change="handleFileUpload" 
                />
                <button class="btn-upload" @click="triggerFileInput">
                    <CameraPlus :size="16" />
                    <span>Carregar foto</span>
                </button>
            </div>
            
            <div class="status-badge" :class="{ 'ativo': instrutorSelecionado.flg_ativo }">
                {{ instrutorSelecionado.flg_ativo ? 'Ativo' : 'Inativo' }}
            </div>
        </div>
        
        <div class="perfil-info">
            <div class="info-section">
                <h3 class="section-title">Informações Pessoais</h3>
                <div class="info-grid">
                    <div class="info-item">
                        <span class="info-label">Nome</span>
                        <span class="info-value">{{ instrutorSelecionado.nome }}</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">CPF</span>
                        <span class="info-value">{{ utils.formatarCPF(instrutorSelecionado.cpf) }}</span>
                    </div>
                    <div class="info-item" v-if="instrutorSelecionado.rg">
                        <span class="info-label">RG</span>
                        <span class="info-value">{{ instrutorSelecionado.rg }}</span>
                    </div>
                    <div class="info-item" v-if="instrutorSelecionado.data_nascimento">
                        <span class="info-label">Data de Nascimento</span>
                        <span class="info-value">{{ formatarData(instrutorSelecionado.data_nascimento) }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import utils from '../../../../services/utils'
import Modal from 'core/Modal'
import AccountCircle from 'icons/AccountCircle'
import CameraPlus from 'icons/CameraPlus'

export default {
    name: 'Perfil',

    components: {
        Modal,
        AccountCircle,
        CameraPlus
    },

    props: {
        instrutorSelecionado: {
            type: Object,
            default: null
        },
        schema: {
            type: String,
            default: null
        }
    },

    data() {
        return {
            utils,
            loading: false,
            fotoPerfil: null,
            uploadLoading: false,
        }
    },

    methods: {

        formatarData(dataString) {
            if (!dataString) return '';
            const data = new Date(dataString);
            return data.toLocaleDateString('pt-BR');
        },

        triggerFileInput() {
            this.$refs.fileInput.click();
        },

        handleFileUpload(event) {
            const file = event.target.files[0];
            if (!file) return;
            
            // Validação do tipo de arquivo
            if (!file.type.includes('image/jpeg') && !file.type.includes('image/jpg')) {
                this.launchToast('Por favor, selecione apenas arquivos JPG');
                return;
            }
            
            // Validação do tamanho (máximo 5MB)
            if (file.size > 5 * 1024 * 1024) {
                this.launchToast('A imagem deve ter no máximo 5MB');
                return;
            }
            
            this.uploadLoading = true;
            
            // Criar uma prévia da imagem para exibição imediata
            const reader = new FileReader();
            reader.onload = (e) => {
                this.fotoPerfil = e.target.result;
            };
            reader.readAsDataURL(file);
            
            const formData = new FormData();
            formData.append('foto', file);
            formData.append('schema', this.schema);
            formData.append('instrutorId', this.instrutorSelecionado.id_instrutor);
            
            this.$http.post(`${process.env.VUE_APP_URL_API_V2}/instrutor/profile/photo/update`, formData)
            .then(response => {
                this.launchToast('Foto atualizada com sucesso!');
            })
            .catch(error => {
                let errorMsg = 'Erro desconhecido';
                if (error.body && error.body.mensagem) {
                    errorMsg = error.body.mensagem;
                }
                this.launchToast('Erro ao enviar a foto: ' + errorMsg);
                this.fotoPerfil = null;
            })
            .finally(() => {
                this.uploadLoading = false;
            });
            
            this.$refs.fileInput.value = '';
        },

        launchToast(mensagem) {
            if (this.$toasted) {
                this.$toasted.show(mensagem, {
                    position: 'top-right',
                });
            } else {
                console.log(mensagem);
            }
        },
        buscarFotoInstrutor() {
            if (!this.instrutorSelecionado || !this.instrutorSelecionado.id_instrutor) {
                return;
            }
            
            this.loading = true;
            
            this.$http.get(`${process.env.VUE_APP_URL_API_V2}/instrutor/profile/photo`, {
                params: { instrutorId: this.instrutorSelecionado.id_instrutor, schema: this.schema }
            })
            .then(response => {
                if (response.body && response.body.data) {
                    this.fotoPerfil = `data:image/jpeg;base64,${response.body.data}`;
                }
            })
            .catch(error => {
                console.error(error.body.message)
                this.launchToast('Erro ao buscar foto do instrutor');
            })
            .finally(() => {
                this.loading = false;
            });
        },
    },
    
    watch: {
        instrutorSelecionado(newVal) {
            if (newVal) {
                this.fotoPerfil = null;
                this.buscarFotoInstrutor();
            }
        }
    },
}
</script>
<style>
.perfil-container {
  min-width: 600px;
  max-width: 800px;
  
  .perfil-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 2rem;
    
    .foto-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0.5rem;
      
      .foto-placeholder {
        width: 120px;
        height: 120px;
        border-radius: 50%;
        background-color: #f5f5f5;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #666;
        overflow: hidden;
        cursor: pointer;
        transition: all 0.2s ease;
        
        &:hover {
          opacity: 0.9;
          box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
        }
        
        .foto-instrutor {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      
      .btn-upload {
        display: flex;
        align-items: center;
        gap: 0.25rem;
        background-color: #f8f9fa;
        border: 1px solid #dee2e6;
        border-radius: 4px;
        padding: 0.25rem 0.5rem;
        font-size: 0.75rem;
        color: #495057;
        cursor: pointer;
        transition: all 0.2s ease;
        
        &:hover {
          background-color: #e9ecef;
        }
        
        span {
          margin-left: 0.25rem;
        }
      }
    }
    
    .status-badge {
      padding: 0.5rem 1rem;
      border-radius: 50px;
      font-weight: 600;
      font-size: 0.875rem;
      background-color: #f44336;
      color: white;
      
      &.ativo {
        background-color: #4caf50;
      }
    }
  }
  
  .perfil-info {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    
    .info-section {
      .section-title {
        font-size: 1.125rem;
        font-weight: 600;
        color: #333;
        margin-bottom: 1rem;
        padding-bottom: 0.5rem;
        border-bottom: 1px solid #eee;
      }
      
      .info-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
        gap: 1rem;
        
        .info-item {
          display: flex;
          flex-direction: column;
          
          .info-label {
            font-size: 0.875rem;
            color: #666;
            margin-bottom: 0.25rem;
          }
          
          .info-value {
            font-size: 1rem;
            color: #333;
            font-weight: 500;
          }
        }
      }
    }
  }
}
</style>